export default ((ref1, ref2) => {
  if (!ref1 || !ref2) {
    return;
  }
  if (typeof ref1 === 'function') {
    ref1(ref2.current);
  } else if (ref2.current) {
    ref1.current = ref2.current;
  }
});
//# sourceMappingURL=mergeRefs.js.map